import { render, staticRenderFns } from "./StructureEditorPdf.vue?vue&type=template&id=01f1558a&scoped=true"
import script from "./StructureEditorPdf.vue?vue&type=script&lang=js"
export * from "./StructureEditorPdf.vue?vue&type=script&lang=js"
import style0 from "./StructureEditorPdf.vue?vue&type=style&index=0&id=01f1558a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1558a",
  null
  
)

export default component.exports